import Vue from 'vue'
import 'vuetify/dist/vuetify.css'
// import '../assets/stylesheets/icon12.css'
import '../assets/stylesheets/icons.css'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VCard,
  VImg,
  VCheckbox,
  VSelect,
  VCombobox,
  VSnackbar,
  VForm,
  VTextField,
  transitions,
  VAutocomplete
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VCard,
    VImg,
    VCheckbox,
    VSelect,
    VCombobox,
    VSnackbar,
    VForm,
    VTextField,
    transitions,
    VAutocomplete
  },
  iconfont: 'md'
})

Vue.use(Vuetify, {
  theme: {
    primary: '#379dcd',
    secondary: '#cecece',
    accent: '#f6f7f8'
    // accent: colors.indigo.base // #3F51B5
  },
  icons: {
    iconfont: 'md',
  }
})
